import { useMutation } from '@tanstack/react-query';

import { warehouseApi } from 'api/warehouse';
import { ApiError } from 'shared/errors/ApiError';

/**
 * Starts an async bulk pallet move and returns the batchId for status polling.
 *
 * @param {Omit<
 *   import('@tanstack/react-query').UseMutationOptions<
 *     { batchId: string },
 *     ApiError,
 *     { palletIds: number[], destinationLocationId: string | number }
 *   >,
 *   'mutationFn'
 * >} [mutationOptions={}]
 */
export function useBulkMovePalletsAsyncMutation(mutationOptions = {}) {
    return useMutation({
        mutationFn: async ({ destinationLocationId, palletIds }) => {
            const response = await warehouseApi.bulkMovePalletsAsync(palletIds, destinationLocationId);
            if (!response?.status || !response.data?.batchId) {
                throw new ApiError(
                    response?.msg || 'Failed to move pallets. Please try again.',
                    response?.statusCode,
                    response?.data,
                );
            }
            return response.data;
        },
        ...mutationOptions,
    });
}
